import { defaultLottieOptions } from './commonLottieConstants';

export const pulsatingDotRedLottieOptions = (isDarkTheme: boolean) => ({
  ...defaultLottieOptions,
  path: isDarkTheme ? 'assets/lottie/PulsatingDotRedDark.json' : 'assets/lottie/PulsatingDotRedLight.json',
});

export const pulsatingDotPurpleLottieOptions = (isDarkTheme: boolean) => ({
  ...defaultLottieOptions,
  path: isDarkTheme ? 'assets/lottie/PulsatingDotPurpleDark.json' : 'assets/lottie/PulsatingDotPurpleLight.json',
});
